<template>
	<div class='speaker-page page'>
		<span class='page-header'>Speaker</span>
		<font-awesome-icon class='speaker-page__background' icon="volume-down" />
		<p class='speaker-page__paragraph'>Open the "Microphone" screen on another device and start recording</p>
	</div>
</template>

<script>
	export default {
		data: function() {
			return {
				record: ''
			}
		},
		sockets: {
        	connect: function() {
            	console.log('Соединение установлено');
        	}
    	},
		beforeMount: function() {
			this.sockets.subscribe('audioMessage', function (audioChunks) {
       			const audioBlob = new Blob(audioChunks);
       		 	const audioUrl = URL.createObjectURL(audioBlob);
        		this.record = new Audio(audioUrl);
        		this.record.play();
    		});
		},
		deactivated: function() {
			this.record.pause();
		}
	}
</script>

<style lang='less'>
	.speaker-page {
		&__background {
			margin-top: 113px;
			font-size: 174px;
			color: #66DCAC;
		}

		&__paragraph {
			padding: 0 43px;
			font-family: Roboto;
			font-weight: 900;
			font-size: 20px;
			line-height: 100%;
			color: #41B883;
			text-align: center;
			margin: 28px 0 0 0;
		}
	}
</style>